export function getFullName(firstName?: string, lastName?: string, middleName: string | null = null) {
  let name = `${firstName}`;

  if (middleName) {
    name = `${name} ${middleName}`;
  }

  name = `${name} ${lastName}`;

  return name;
}

export function formatDisplayName(firstName?: string, lastName?: string, nickname?: string): string {
  const first = firstName?.trim() ?? '';
  const last = lastName?.trim() ?? '';
  const nick = nickname?.trim() ?? '';

  let displayFirst = first;
  if (nick && nick.toLowerCase() !== first.toLowerCase()) {
    displayFirst = `${first} (${nick})`;
  }

  return [displayFirst, last].filter(Boolean).join(' ');
}

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmailAddress(email: string) {
  return EMAIL_PATTERN.test(email);
}

export function escapeRegExp(string: string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function nameMatchScore(name: string | undefined, query: string): number {
  if (!name || !query) return 0;

  const n = name.trim().toLowerCase();
  const q = query.trim().toLowerCase();
  if (!n || !q) return 0;

  if (n === q) return 3;
  if (n.startsWith(q)) return 2;
  if (new RegExp(`\\b${escapeRegExp(q)}`, 'i').test(n)) return 1;
  if (n.includes(q)) return 0.5;

  return 0;
}
